import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

// ⚠️ PASTE YOUR FIREBASE CONFIG DETAILS HERE
// (You can copy this from your Firebase Console under Project Settings > Web App)
const firebaseConfig = {
  apiKey: "AIzaSyAxb8yAO43feBy4BdcWGufJslQquGgLUZo",
  authDomain: "uptask-39489.firebaseapp.com",
  projectId: "uptask-39489",
  storageBucket: "uptask-39489.firebasestorage.app",
  messagingSenderId: "581870567297",
  appId: "1:581870567297:web:c26a1489e0bc36b4833280"
};

// ⚠️ PASTE YOUR FIREBASE WEB PUSH VAPID KEY HERE
// (You can get this from Firebase Project Settings > Cloud Messaging > Web Push certificates)
const VAPID_KEY = "BHfVvMFe_u-5IowQfdUImvsMDRBl8M4_-Zb7xo3BcOUnmEGY7nD_Ka6yRzKe3Gr1X2R5OKEWgGQCe9xxjMlLcRg";

let messaging = null;

try {
  // Only initialize if placeholders have been replaced
  if (firebaseConfig.apiKey !== "YOUR_API_KEY") {
    const app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  } else {
    console.log("[FCM] Running with placeholders. Please configure your credentials in src/firebase.js to activate Web Push.");
  }
} catch (err) {
  console.warn("⚠️ Firebase Initialization failed:", err.message);
}

export const requestFcmToken = async () => {
  if (!messaging) {
    console.log("[FCM] Messaging not initialized – configure credentials in src/firebase.js");
    return null;
  }
  
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("[FCM] Notification permission was denied.");
      return null;
    }

    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (token) {
      console.log("[FCM] Retrieved FCM Token successfully.");
      return token;
    }
  } catch (err) {
    console.error("[FCM] Error retrieving FCM Token:", err);
  }
  return null;
};
